import Hls from "hls.js";
import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import Loading from "../loading";
import dayjs from "dayjs";
import PlayerCustom from "../components/PlayerCustom";

export default function Home() {
  const [linkHome, setLinkHome] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [dataLive, setDataLive] = useState({});
  const [listLive, setListLive] = useState();
  const [listHot, setListHot] = useState();
  const [paging, setPaging] = useState({ current: 1, pageSize: 8 });
  const [isShowLoadMore, setIsShowLoadMore] = useState(false);
  const [urlPlayer, setUrlPlayer] = useState();
  const [liveDt, setLiveDt] = useState();

  useEffect(() => {
    fetchData();
    listDataLive();
    fetchListHot();
  }, []);

  const fetchData = async () => {
    setIsLoading(true);
    try {
      var myHeaders = new Headers();
      myHeaders.append("Cookie", "SERVER=api2");

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        redirect: "follow",
      };

      const response = await fetch(
        "https://api.553328.com/api/get-live-homepage",
        requestOptions
      );

      const data = await response.json();
      setDataLive(data?.value?.data);
      setUrlPlayer(data?.value?.data?.linkLive);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchListHot = async () => {
    setIsLoading(true);
    try {
      var myHeaders = new Headers();
      myHeaders.append("Cookie", "SERVER=api2");

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        redirect: "follow",
      };
      const res = await fetch(
        "https://api.553328.com/api/get-list-live-homepage",
        requestOptions
      );
      const data = await res.json();
      setListHot(data?.value?.data);
      setIsLoading(false);
    } catch (error) {
      console.log("error", error);
    }
  };

  const listDataLive = async () => {
    setIsLoading(true);
    try {
      var myHeaders = new Headers();
      myHeaders.append("Cookie", "SERVER=api2");

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        redirect: "follow",
      };
      const response = await fetch(
        `https://api.553328.com/api/get-livestream?current=${paging.current}&pageSize=${paging.pageSize}`,
        requestOptions
      );
      const data = await response.json();
      if (
        data?.value?.datas?.length === 0 ||
        data?.value?.datas?.length > paging.pageSize
      );
      {
        setIsShowLoadMore(true);
        const _paging = {
          current: paging.current + 1,
          pageSize: paging.pageSize,
        };
        setPaging(_paging);
        setListLive(data?.value?.datas || []);
        setIsLoading(false);
      }
    } catch (error) {
      console.error("Error list live", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSeeMore = async () => {
    try {
      var myHeaders = new Headers();
      myHeaders.append("Cookie", "SERVER=api2");
      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        redirect: "follow",
      };
      const response = await fetch(
        `https://api.553328.com/api/get-livestream?current=${paging.current}&pageSize=${paging.pageSize}`,
        requestOptions
      );
      const data = await response.json();
      if (
        data?.value?.datas?.length === 0 ||
        data?.value?.datas?.length > paging.pageSize
      );
      {
        setIsShowLoadMore(true);
        const _paging = {
          current: paging.current + 1,
          pageSize: paging.pageSize,
        };
        setPaging(_paging);
        setListLive([...listLive, ...data?.value?.datas]);
        setIsLoading(false);
      }
    } catch (error) {
      console.error("Error list live", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleClickHot = (e, data) => {
    e.preventDefault();
    setUrlPlayer(data.linkLive);
    const livefind = listHot.find((dataLiveLink) => {
      return dataLiveLink.linkLive === data.linkLive;
    });
    setLiveDt(livefind);
  };
  return (
    <>
      <div className="mx-auto flex gap-2 container lg:h-[570px] xl:h-[600px] lg:px-2 xl:gap-4 xl:p-0  3xl:h-[765px]">
        {/* <PlayerCustom urlVideo={urlPlayer} /> */}
        <video
          className="w-full lg:w-4/5 object-cover"
          src="https://ok9.blog/wp-content/uploads/2024/07/video-home.mp4"
          controls
          autoPlay
          muted
          loop
        ></video>
        <div className="tranhot  h-full flex-col justify-start lg:flex lg:gap-2 lg:w-1/5">
          <div className="h-auto bg-gradient-to-b from-[#36a638] to-[#36a638] rounded-lg border border-[#36a638] font-medium p-1 text-sm text-white flex item-center justify-center btnMatchHot">
            <p>CÁC TRẬN HOT</p>
          </div>
          <div className="flex flex-col justify-start gap-1 lg lg:h-[527px] xl:h-[535px] 3xl:h-[765px]">
            {listHot?.map((dt, i) => (
              <div
                key={i}
                className="relative h-1/4"
                onClick={(e) => handleClickHot(e, dt)}
              >
                <button className="block z-10 w-full h-full border  rounded-xl bg-[url('https://ok9.blog/wp-content/uploads/2024/07/bgitem.webp')] bg-cover bg-no-repeat bg-center cursor-pointer transition-transform duration-300 hover:-translate-y-1">
                  <div className="flex items-center justify-between py-1 px-2 border-b border-[#36a638] w-full h-1/5">
                    <p className="truncate text-white font-bold text-xs md:text-sm xl:text-base !mb-0">
                      {dt.leagueName}
                    </p>
                    {dt.status === 0 ? (
                      <></>
                    ) : (
                      <>
                        <div className="text-[11px] flex gap-1 bg-[#ff0000] text-white rounded px-1 pt-0.5 font-semibold lg:text-sm">
                          <div class="whitespace-nowrap">
                            <div class="flex items-center justify-center gap-1 pb-0.5">
                              <img
                                src="https://ok9.blog/wp-content/uploads/2024/07/live.webp"
                                alt=""
                                class="object-contain w-3.5"
                              />
                              <span class="font-medium text-xs">LIVE</span>
                            </div>
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                  <div className="flex items-center justify-center text-white py-2 px-1 md:py-4 md:px-2 w-full h-3/5">
                    <div className="flex flex-col items-center justify-center w-1/3">
                      <div className="flex items-center w-8 h-8 md:w-14 md:h-14">
                        <img
                          className="object-contain rounded-full w-full h-full bg-white"
                          src={dt.homeLogo}
                          alt={dt.homeName}
                        />
                      </div>
                      <p className="text-white text-xs text-center truncate w-full mt-1 !mb-0">
                        {dt.homeName}
                      </p>
                    </div>
                    <div className="flex flex-col items-center justify-center w-1/3">
                      <div className="flex flex-col items-center justify-center text-xs gap-1 md:flex-row xl:text-base">
                        <span className="text-white whitespace-nowrap">
                          {dayjs.unix(dt.matchTime).format("HH:mm")}
                        </span>
                        <span className="text-white whitespace-nowrap">
                          {dayjs.unix(dt.matchTime).format("DD/MM")}
                        </span>
                      </div>
                      <p className="font-bold !mb-0">VS</p>
                    </div>
                    <div className="flex flex-col items-center justify-center w-1/3">
                      <div className="flex items-center w-8 h-8 md:w-14 md:h-14">
                        <img
                          className="object-contain rounded-full w-full h-full bg-white"
                          src={dt.awayLogo}
                          alt={dt.awayName}
                        />
                      </div>
                      <p className="text-white text-xs text-center truncate w-full mt-1 !mb-0">
                        {dt.awayName}
                      </p>
                    </div>
                  </div>
                  <div class="bg-[#091943] flex items-center rounded-b-lg justify-between border-t border-[#36a638] w-full h-1/4 lg:rounded-b-xl lg:h-1/5">
                    <div class="flex items-center justify-center gap-2 h-full w-full py-0 px-2 lg:py-1">
                      <p class="truncate text-white font-semibold text-[11px] md:text-sm xl:text-base !mb-0">
                        {dt.commentator}
                      </p>
                    </div>
                  </div>
                </button>
                {liveDt?.matchId === dt?.matchId && (
                  <span className="w-0 h-0 border-t-8 border-t-transparent border-b-8 border-b-transparent border-r-[10px] border-gray-900 absolute top-1/2 -translate-y-1/2 -translate-x-[100%] transition-all"></span>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>

      {isLoading ? (
        <Loading />
      ) : (
        <div className="container py-4 px-2 mx-auto w-full grid grid-cols-2 gap-2 sm:grid-cols-2 lg:mt-6 lg:gap-x-10 lg:gap-y-8 lg:grid-cols-3 xl:grid-cols-4 xl:px-0">
          {listLive?.map((item, index) => (
            <Link
              to={`/live/${item.matchId}`}
              key={index}
              className="block z-10 w-full h-full border border-[#36a638] rounded-lg bg-[url('https://ok9.blog/wp-content/uploads/2024/07/bgitem.webp')] bg-cover	bg-no-repeat bg-center cursor-pointer transition-transform duration-300 hover:-translate-y-1"
            >
              <div className="flex items-center justify-between py-1 px-2 border-b border-[#36a638] w-full h-1/5">
                <p className="truncate text-white font-bold text-xs md:text-sm xl:text-base !mb-0">
                  {item.leagueShortName}
                </p>
                {item.status === 0 ? (
                  <></>
                ) : (
                  <>
                    <div className="text-[11px] flex gap-1 bg-[#ff0000] text-white rounded px-1 pt-0.5 font-semibold lg:text-sm">
                      <div class="whitespace-nowrap">
                        <div class="flex items-center justify-center gap-1 pb-0.5">
                          <img
                            src="https://ok9.blog/wp-content/uploads/2024/07/live.webp"
                            alt=""
                            class="object-contain w-3.5"
                          />
                          <span class="font-medium text-xs">LIVE</span>
                        </div>
                      </div>
                    </div>
                  </>
                )}
              </div>
              <div className="flex items-center justify-center text-white py-2 px-1 md:py-4 md:px-2 w-full">
                <div className="flex flex-col items-center justify-center w-1/3">
                  <div className="flex items-center w-8 h-8 md:w-14 md:h-14">
                    <img
                      className="object-contain rounded-full w-full h-full bg-white"
                      src={item.homeLogo}
                      alt={item.homeName}
                    />
                  </div>
                  <p className="text-white text-xs text-center truncate w-full mt-1 !mb-0">
                    {item.homeName}
                  </p>
                </div>
                <div className="flex flex-col items-center justify-center w-1/3">
                  <div className="flex flex-col items-center justify-center text-xs gap-1 md:flex-row xl:text-base">
                    <span className="text-white whitespace-nowrap">
                      {dayjs.unix(item.matchTime).format("HH:mm")}
                    </span>
                    <span className="text-white whitespace-nowrap">
                      {dayjs.unix(item.matchTime).format("DD/MM")}
                    </span>
                  </div>
                  <p className="font-bold text-white !mb-0">VS</p>
                </div>
                <div className="flex flex-col items-center justify-center w-1/3">
                  <div className="flex items-center w-8 h-8 md:w-14 md:h-14">
                    <img
                      className="object-contain rounded-full w-full h-full bg-white"
                      src={item.awayLogo}
                      alt={item.awayName}
                    />
                  </div>
                  <p className="text-white text-xs text-center truncate w-full mt-1 !mb-0">
                    {item.awayName}
                  </p>
                </div>
              </div>
              <div className='class="bg-neutral-900 flex items-center rounded-b-lg justify-center border-t border-[#36a638] w-full h-1/5"'>
                <p className="truncate text-white font-bold text-xs md:text-sm xl:text-base py-2 !mb-0">
                  {item.commentator}
                </p>
              </div>
            </Link>
          ))}
        </div>
      )}
      {isShowLoadMore && (
        <div className="flex items-center justify-center cursor-pointer xl:mt-10 pb-3">
          <button
            className="inline uppercase cursor-pointer transition-transform duration-300 hover:-translate-y-1 h-auto bg-gradient-to-b from-[#36a638] to-[#36a638] rounded-lg border border-[#36a638] font-medium p-1 text-xl text-white item-center justify-center btnMatchHot"
            onClick={handleSeeMore}
          >
            các trận đấu khác
          </button>
        </div>
      )}
    </>
  );
}
